import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { region } from "../../../store/region/actions";
export var useGetRegions = function (trigger, type, parentRegionId) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responseRegion: state.Region.responseRegion,
        errorRegion: state.Region.errorRegion,
        loadingRegion: state.Region.loadingRegion,
    }); }), responseRegion = _a.responseRegion, errorRegion = _a.errorRegion, loadingRegion = _a.loadingRegion;
    useEffect(function () {
        if (trigger) {
            dispatch(region({
                enable: true,
                page: 1,
                limit: 1000,
                level: type,
                parentRegionId: parentRegionId,
            }));
        }
    }, [type, parentRegionId, trigger]);
    return {
        responseRegion: responseRegion,
        errorRegion: errorRegion,
        loadingRegion: loadingRegion,
    };
};
